module.exports = __webpack_public_path__ + "img/1_fineTeam_zsb.b64d8307.png";